import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

import TextField from '../../artzu-ui/src/TextField';

export default class TextInput extends ValidatorComponent {
  render() {
    const {
      floatingLabelText = '',
      onChange = () => {},
      name = '',
      type = '',
      value = '',
      inverted = false,
      error = '',
    } = this.props;
    const { isValid } = this.state;
    return (
      <TextField
        password={type === 'password'}
        error={error || (!isValid && this.getErrorMessage())}
        heading={floatingLabelText}
        name={name}
        value={value}
        width="100%"
        inverted={inverted}
        onChange={onChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewProfile/TextInput.js